module.exports = __webpack_public_path__ + "img/172.6a727dfd.jpg";